import most from 'most'

export default function(key){
  return function(save$){
    // save values from sink to localstorage
    save$.subscribe({
      next: function(i){
        console.log("ON NEXT OMG OMG! :D",i,i && i.length, typeof i)
        localStorage.setItem(key,i);
      }
    });
    // return existing saved value as a source
    return most.just(localStorage.getItem(key))
  }
}


/** WEBPACK FOOTER **
 ** ./storedriver.js
 **/